// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"_2cK7J","skeleton":"QnAMh","pulseSkeleton":"_39ORF","pulse":"BFTB8","skeletonArray":"_1d7Wi","skeletonWrapperDirection":"_3Cufu"};